import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { SsoDomainService } from '../../../core/services/sso-domain.service';
import { LoadingService } from '../../../core/services/loading.service';
import { SsoDomain } from '../../../core/models/SsoDomain';
import { AsyncPipe } from '@angular/common';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';
import { blockedDomainsValidator } from '../../../core/validators/blocked-domain.validator';

@Component({
  selector: 'app-edit-domain-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    AsyncPipe,
    LoadingSpinnerComponent
  ],
  templateUrl: './edit-domain-dialog.component.html',
  styleUrl: './edit-domain-dialog.component.css',
})
export class EditDomainDialogComponent {
  editDomainForm: FormGroup;
    errorMessage: string = '';
    isSubmitting: boolean = false;
    private ssoDomainService = inject(SsoDomainService);
    loadingService = inject(LoadingService);
    ssoDomain: SsoDomain;

  constructor(
    private dialogRef: MatDialogRef<EditDomainDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: SsoDomain
  ) {
    this.ssoDomain = data;
    this.editDomainForm = this.fb.group({
      domain: ['', [
        Validators.required, 
        Validators.pattern(/^(?!-)(xn--)?([a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,63}$/), 
        blockedDomainsValidator(),
      ]]
    });
  }

  onSubmit() {
    if (this.editDomainForm.valid) {
      this.isSubmitting = true;
      this.errorMessage = '';
      
      this.ssoDomainService.updateSsoDomain(this.ssoDomain, this.editDomainForm.value.domain).subscribe({
        next: (updatedDomain) => {
          this.dialogRef.close(updatedDomain);
        },
        error: (error: string) => {
          console.error('Domain edit error:', error);
          this.isSubmitting = false;
          this.errorMessage = error;
        }
      });
    }
  }

  onCancel() {
    this.dialogRef.close();
  }
}